import { Component, Input, OnInit } from '@angular/core';
import { APIReferenceManagementCard } from 'src/app/model/card/api-reference-management-card';

import { documentToHtmlString } from '.';

@Component({
  selector: 'app-api-reference-management-card',
  templateUrl: './api-reference-management-card.component.html',
  styleUrls: ['./api-reference-management-card.component.scss']
})
export class APIReferenceManagementCardComponent {
  @Input() titleHeading: string = '';
  @Input() apiReferenceManagementCards: APIReferenceManagementCard[] = [];
  constructor() {}

  returnHtmlFromRichText(richText: any): string {
    if (richText === undefined || richText === null || richText.nodeType !== 'document') {
      return '<p>Error</p>';
    }

    return documentToHtmlString(richText);
  }
}
